import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Researcher from "@/pages/Researcher";

export const Route = createFileRoute("/pl/researcher")({
  head: () => routeHead('AGAPE Researcher — Raport B2B', META_DESCRIPTIONS.researcher.pl, '/pl/researcher'),
  component: Researcher,
});
